import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=217974e9&"
import script from "./Poll.vue?vue&type=script&lang=js&"
export * from "./Poll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Poll.vue"
export default component.exports